<template>
    <div class="page">
        <div class="form">
            <div class="form-title">经销商注册</div>

            <!-- 名称 -->
            <div class="title">
                <van-icon name="user-o" color="#000000" />
                <div class="name">名称</div>
            </div>
            <van-field
                class="input"
                v-model="form.name"
                border
                placeholder="请输入名称"
            />

            <!-- 手机号（账号） -->
            <div class="title">
                <van-icon name="user-o" color="#000000" />
                <div class="name">手机号（账号）</div>
            </div>
            <van-field
                class="input"
                v-model="form.phone"
                type="tel"
                border
                placeholder="请输入手机号"
                maxlength="11"
            />

            <!-- 密码 -->
            <div class="title password">
                <img src="../../assets/my/in2.png" alt="" />
                <div class="name">密码</div>
            </div>
            <van-field
                class="input"
                type="password"
                v-model="form.password"
                border
                placeholder="请输入密码"
            />

            <!-- 确认密码 -->
            <div class="title password">
                <img src="../../assets/my/in2.png" alt="" />
                <div class="name">确认密码</div>
            </div>
            <van-field
                class="input"
                type="password"
                v-model="form.confirmPassword"
                border
                placeholder="请再次输入密码"
            />

            <!-- 公司名称 -->
            <div class="title password">
                <van-icon name="desktop-o" color="#000000" />
                <div class="name">公司名称</div>
            </div>
            <van-field
                class="input"
                v-model="form.companyName"
                border
                placeholder="请输入公司名称"
            />

            <!-- 所属地区 -->
            <div class="title password">
                <van-icon name="location-o" color="#000000" />
                <div class="name">所属地区</div>
            </div>
            <van-field
                class="input"
                v-model="form.region"
                readonly
                border
                placeholder="请选择所属地区"
                @click="showAreaPicker = true"
            />
            <van-popup v-model="showAreaPicker" position="bottom">
                <van-area
                    :area-list="areaList"
                    @confirm="onAreaConfirm"
                    @cancel="showAreaPicker = false"
                />
            </van-popup>

            <!-- 图片验证码 -->
            <div class="title password">
                <van-icon name="qr" color="#000000" />
                <div class="name">图片验证码</div>
            </div>
            <div class="verify-code-wrapper">
                <van-field
                    class="input verify-input"
                    v-model="form.verifyCode"
                    border
                    placeholder="请输入验证码答案"
                />
                <div class="verify-code-box">
                    <verify-code
                        ref="verifyCode"
                        @code-generated="onCodeGenerated"
                    />
                </div>
            </div>

            <div class="radio">
                <van-checkbox v-model="checked" icon-size="15px">
                    <div class="tips">
                        我已同意接受 <span>用户协议</span> 和
                        <span>隐私政策</span>
                    </div>
                </van-checkbox>
            </div>
            <van-button
                class="button"
                :loading="button.loading"
                :disabled="button.disabled"
                @click="submit"
                :loading-text="button.text"
            >
                {{ button.text }}
            </van-button>
            <div class="register" @click="goLogin">已有账号，前往登录</div>
        </div>
    </div>
</template>

<script>
import VerifyCode from "@/components/verifyCode/index.vue";
import { Toast } from "vant";
import { areaList } from "@vant/area-data";
import { userRegister } from "@/api/scrm";
export default {
    name: "Register",
    components: {
        VerifyCode,
    },
    data() {
        return {
            button: { loading: false, disabled: false, text: "注 册" },
            form: {
                name: "",
                phone: "",
                password: "",
                confirmPassword: "",
                companyName: "",
                region: "",
                regionCode: "",
                verifyCode: "",
            },
            checked: false,
            showAreaPicker: false,
            areaList: areaList,
            correctVerifyCode: null, // 存储验证码正确答案
        };
    },
    methods: {
        // 验证码生成回调
        onCodeGenerated(correctResult) {
            this.correctVerifyCode = correctResult;
        },
        // 地区选择确认
        onAreaConfirm(values) {
            const names = values.map((item) => item.name);
            const codes = values.map((item) => item.code);
            this.form.region = names.join(" ");
            this.form.regionCode = codes.join(",");
            this.showAreaPicker = false;
        },
        // 验证手机号
        validatePhone(phone) {
            const reg = /^1[3-9]\d{9}$/;
            return reg.test(phone);
        },
        // 提交注册
        submit() {
            // 验证名称
            if (!this.form.name || this.form.name.trim() === "") {
                return Toast({ position: "top", message: "请输入名称" });
            }
            // 验证手机号
            if (!this.form.phone || this.form.phone.trim() === "") {
                return Toast({ position: "top", message: "请输入手机号" });
            }
            if (!this.validatePhone(this.form.phone)) {
                return Toast({
                    position: "top",
                    message: "请输入正确的手机号",
                });
            }
            // 验证密码
            if (!this.form.password || this.form.password.trim() === "") {
                return Toast({ position: "top", message: "请输入密码" });
            }
            if (this.form.password.length < 6) {
                return Toast({
                    position: "top",
                    message: "密码长度不能少于6位",
                });
            }
            // 验证确认密码
            if (
                !this.form.confirmPassword ||
                this.form.confirmPassword.trim() === ""
            ) {
                return Toast({ position: "top", message: "请再次输入密码" });
            }
            if (this.form.password !== this.form.confirmPassword) {
                return Toast({
                    position: "top",
                    message: "两次输入的密码不一致",
                });
            }
            // 验证公司名称
            if (!this.form.companyName || this.form.companyName.trim() === "") {
                return Toast({ position: "top", message: "请输入公司名称" });
            }
            // 验证所属地区
            if (!this.form.region || this.form.region.trim() === "") {
                return Toast({ position: "top", message: "请选择所属地区" });
            }
            // 验证验证码
            if (!this.form.verifyCode || this.form.verifyCode.trim() === "") {
                return Toast({ position: "top", message: "请输入验证码" });
            }
            if (!this.$refs.verifyCode.validate(this.form.verifyCode)) {
                this.form.verifyCode = "";
                this.$refs.verifyCode.refreshCaptcha();
                return Toast({
                    position: "top",
                    message: "验证码错误，请重新输入",
                });
            }
            // 验证协议
            if (!this.checked) {
                return Toast({
                    position: "top",
                    message: "请先同意用户协议和隐私政策",
                });
            }

            // 提交注册
            this.button.disabled = true;
            this.button.loading = true;
            this.button.text = "注册中...";

            userRegister({
                name: this.form.name,
                phone: this.form.phone,
                password: this.form.password,
                confirm_password: this.form.confirmPassword,
                company_name: this.form.companyName,
                area: this.form.region,
            })
                .then((res) => {
                    if (res.code == 1) {
                        Toast.success("注册成功,请等待审核");
                        this.$router.push({ name: "login" });
                    } else {
                        Toast.fail(res.msg);
                    }
                })
                .finally(() => {
                    this.button.disabled = false;
                    this.button.loading = false;
                    this.button.text = "注 册";
                });
        },
        // 前往登录
        goLogin() {
            this.$router.push({ name: "login" });
        },
    },
};
</script>

<style scoped lang="less">
.page {
    min-height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.page .form {
    background: #ffffff;
    position: relative;
    overflow: hidden;
    flex: 1;
    padding: var(--base-px-50) var(--base-px-25) var(--base-px-25);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.form-title {
    font-size: var(--base-px-24);
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: var(--base-px-30);
}

.page .form .title {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    font-size: var(--base-px-14);
    margin-bottom: var(--base-px-10);
    margin-top: var(--base-px-15);
}

.page .form .title:first-of-type {
    margin-top: 0;
}

.page .form .title.password {
    margin-top: var(--base-px-25);
}

.page .form .title img {
    width: var(--base-px-12);
    margin-right: var(--base-px-5);
}

.page .form .input {
    height: var(--base-px-45);
    background: #f5f7f7;
    border-radius: var(--base-px-24);
}

.verify-code-wrapper {
    display: flex;
    align-items: center;
    gap: var(--base-px-10);
}

.verify-code-wrapper .verify-input {
    flex: 1;
}

.verify-code-box {
    flex-shrink: 0;
}

.page .form .radio {
    margin-left: var(--base-px-10);
    margin-top: var(--base-px-25);
}

.page .form .tips {
    font-size: var(--base-px-12);
    font-weight: 400;
    color: #666666;
}

.page .form .tips span {
    color: #117de9;
}

.page .form .button {
    width: 100%;
    background: linear-gradient(to right, #117de9, #2b62cc);
    color: #ffffff;
    font-weight: bold;
    border-radius: var(--base-px-30);
    margin-top: var(--base-px-15);
}

.register {
    color: #117de9;
    text-align: right;
    margin-top: var(--base-px-20);
    font-size: var(--base-px-12);
    text-decoration: underline;
    cursor: pointer;
}
</style>
